export default __webpack_public_path__ + "static/media/mode-534.79541f5a.svg";